module.exports = __webpack_public_path__ + "img/timeline-a24790.png";